<script>
    export let toolTip = '';
    export let bold = false;
</script>

<style>
    :global(.contextual) {
        color: #0B6CB3;
    }

    .bold {
        font-weight: bold;
    }
</style>

<span class:bold={bold} class="contextual" title="{toolTip}"><slot></slot></span>
